module.exports = __webpack_public_path__ + "media/images/icons/SVG/013-8ac55abb7c2655d7a80521d0c032a3e7.svg";